import { uploadFile, deleteStoredFile, objectFileName } from '../../../api/files';

const MAX_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
]);

export function validateSupportTicketAttachment(file) {
  if (!file) return { ok: false, error: 'No file selected.' };
  if (!ALLOWED_TYPES.has(file.type)) {
    return { ok: false, error: 'Allowed file types: PDF, JPG, PNG, WEBP, GIF.' };
  }
  if (file.size > MAX_SIZE) {
    return { ok: false, error: 'Max file size is 5MB.' };
  }
  return { ok: true };
}

export async function uploadSupportTicketAttachments({ companyId, ticketId, files }) {
  if (!companyId || !ticketId) throw new Error('Missing companyId or ticketId');
  if (!files || files.length === 0) return [];

  const uploads = [];
  for (const file of files) {
    const v = validateSupportTicketAttachment(file);
    if (!v.ok) throw new Error(v.error);

    const storagePath = `companies/${companyId}/supportTickets/${ticketId}/attachments/${objectFileName(file)}`;
    const stored = await uploadFile(file, storagePath);

    uploads.push({
      name: file.name,
      contentType: file.type,
      size: file.size,
      storagePath,
      url: stored.url,
      uploadedAt: new Date().toISOString(),
    });
  }

  return uploads;
}

export { deleteStoredFile };
